import React, { useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { useAttendeeMode } from '@context/attendeeModeContext';
import { SearchModeContext } from '@context/searchModeContext';
import useAttendeePdfs from '@hooks/useAttendeePdfs';
import { CurrentFilters, PageSizeDropdown, SortByDropdown, SearchStatsGlobal } from '@search';
import AttendeePdfLink from '../../../../../attendee-pdf-access/js/components/AttendeePdfLink';
import FiltersOverlay from '../FiltersOverlay';
import FilterButton from '../../elements/FilterButton';
import { formatFilterLabel } from '../../../helpers/formatContentTypeLabel';

const SearchOptionsMobile = ({ onPageSizeChange, onSortByChange }) => {
    const { showFilters } = useContext(SearchModeContext);
    const { eventCode } = useAttendeeMode() ?? {};
    const { pdfGroups } = useAttendeePdfs(eventCode);
    const [filterModalOpen, setFilterModalOpen] = useState(false);

    useEffect(() => {
        if (filterModalOpen) {
            document.body.style.position = 'fixed';
        } else {
            document.body.style.position = 'static';
        }
    }, [filterModalOpen]);

    return (
        <div className="mt-3">
            <div className="align-self-center mb-3 text-center">
                <SearchStatsGlobal />
            </div>

            {showFilters && (
                <div className="mb-3">
                    <FilterButton
                        onClick={() => {
                            setFilterModalOpen(true);
                        }}
                    />
                </div>
            )}

            <div className="mb-3">
                <CurrentFilters
                    buttonClasses="display8"
                    clearAllClasses="font-sans leading-6 text-base"
                    formatLabel={formatFilterLabel}
                />
            </div>

            <div className="listing-filters d-flex justify-content-between">
                <li className="nav-item dropdown d-inline-block my-md-auto mr-md-5 align-self-center">
                    <SortByDropdown onSortByChange={onSortByChange} />
                </li>

                <li className="nav-item dropdown d-inline-block my-md-auto mr-md-5 align-self-center">
                    <PageSizeDropdown onPageSizeChange={onPageSizeChange} />
                </li>
            </div>

            <div className="d-flex justify-content-center">
                {pdfGroups.length > 0 && (
                    <AttendeePdfLink pdfGroups={pdfGroups} eventCode={eventCode} className="text-sm accent" id="attendee-pdf-download" />
                )}
            </div>

            {showFilters && <FiltersOverlay open={filterModalOpen} onClose={() => setFilterModalOpen(false)} />}
        </div>
    );
};

SearchOptionsMobile.propTypes = {
    onPageSizeChange: PropTypes.func.isRequired,
    onSortByChange: PropTypes.func.isRequired,
};

export default SearchOptionsMobile;
